export const resources = {
  en: {
    translation: {
      app: {
        name: 'CCA-App',
        language: 'Language',
        navigationMenu: 'Navigation menu',
        activeOrganisation: 'Organisation',
      },
      common: {
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        details: 'Details',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        retry: 'Retry',
        refresh: 'Refresh',
        create: 'Create',
        rename: 'Rename',
        upload: 'Upload',
        open: 'Open',
        noData: 'No data',
        optional: 'Optional',
        actions: 'Actions',
        loading: 'Loading...',
        notSet: 'Not set',
        remove: 'Remove',
        description: 'Description',
        replace: 'Replace',
        preview: 'Preview',
        updateDueDate: 'Update due date',
        turnOffDueDate: 'Turn off due date',
        dueDate: 'Due date',
        notes: 'Notes',
        updateNotes: 'Update notes',
      },
      auth: {
        loginTitle: 'Sign in',
        loginSubtitle: 'Use your organisation account to access ConstAdmin.',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm password',
        signIn: 'Sign in',
        signOut: 'Sign out',
        loginFailed: 'Sign in failed. Check your email and password.',
        forgotPassword: 'Forgot password?',
        forgotPasswordTitle: 'Reset your password',
        forgotPasswordSubtitle: 'Enter your account email and we will send you a link to choose a new password.',
        forgotPasswordSent: 'If an account exists for that email, you will receive password reset instructions shortly.',
        forgotPasswordFailed: 'Could not start password reset. Please try again.',
        sendResetLink: 'Send reset link',
        resetUrlDevHint: 'Email is disabled — use this reset link:',
        resetPasswordTitle: 'Choose a new password',
        resetPasswordSubtitle: 'Enter a new password for your account.',
        resetPassword: 'Reset password',
        newPassword: 'New password',
        passwordResetSuccess: 'Password updated. Redirecting to sign in...',
        passwordResetFailed: 'Could not reset password. The link may have expired.',
        backToSignIn: 'Back to sign in',
        inviteTitle: 'Accept invitation',
        inviteSubtitle: 'Set a password to join your organisation.',
        acceptInvite: 'Accept invitation',
        inviteAccepted: 'Invitation accepted for {{email}}. Redirecting to sign in...',
        inviteFailed: 'Could not accept the invitation.',
        passwordMismatch: 'Passwords do not match.',
      },
      users: {
        title: 'Users and invites',
        inviteUser: 'Invite user',
        members: 'Members',
        pendingInvites: 'Pending invites',
        role: 'Role',
        sendInvite: 'Send invite',
        revoke: 'Revoke',
        expiresAt: 'Expires',
        adminOnly: 'Only organisation admins and platform admins can access this page.',
        loadFailed: 'Could not load users.',
        inviteFailed: 'Could not create invite.',
        revokeFailed: 'Could not revoke invite.',
        inviteCreated: 'Invite created. Share this link: {{url}}',
        inviteSent: 'Invite sent to {{email}}.',
        inviteEmailFailed: 'Could not send invite email. Please try again.',
        organisationSettings: 'Organisation settings',
        organisationName: 'Organisation name',
        organisationSlug: 'Slug (optional)',
        organisationSlugHint: 'Used for URLs; leave empty if not needed.',
        organisationSaved: 'Organisation updated.',
        organisationSaveFailed: 'Could not update organisation.',
        dailyWorkHoursFormat: 'Daily work hours format',
        dailyWorkHoursFormatHours: 'Number of hours',
        dailyWorkHoursFormatTimeRange: 'Time range (from–till)',
        defaultWorkStartTime: 'Default work hours from',
        defaultWorkEndTime: 'Default work hours till',
        lunchDurationMinutes: 'Lunch duration (minutes)',
        lunchIsPartOfWorkHours: 'Lunch counts as work time',
        defaultUsedLunch: 'Lunch enabled by default',
        editEmail: 'Edit email',
        emailSaved: 'Email updated.',
        emailSaveFailed: 'Could not update email.',
        platformOrganisations: 'Platform organisations',
        platformOrganisationsHint: 'Manage organisation names for any tenant on the platform.',
        selectOrganisation: 'Organisation',
        createOrganisation: 'New organisation',
        organisationCreateFailed: 'Could not create organisation.',
        joinAsAdmin: 'Join as admin',
        joinedOrganisation: 'You are now an admin of this organisation. Switch to it from the menu.',
        joinFailed: 'Could not join the organisation.',
        rolesTab: 'Roles',
        createRole: 'Create role',
        editRole: 'Edit role',
        roleName: 'Role name',
        roleSaved: 'Role saved.',
        roleSaveFailed: 'Could not save role.',
        roleUpdated: 'User role updated.',
        roleUpdateFailed: 'Could not update role.',
        removeMember: 'Remove',
        removeMemberConfirm: 'Remove {{email}} from this organisation? Their login account will be deleted if they belong to no other organisation.',
        memberRemoved: 'User removed from the organisation.',
        memberRemovedAccountDeleted: 'User removed and their account was deleted.',
        memberRemoveFailed: 'Could not remove user.',
        projectsUpdated: 'Project assignments updated.',
        projectsUpdateFailed: 'Could not update project assignments.',
        assignedProjects: 'Assigned projects',
        allProjects: 'All projects',
        projects: 'Projects',
        type: 'Type',
        adminRole: 'Admin',
        systemRole: 'System',
        customRole: 'Custom',
        viewPermissions: 'View permissions',
        invitePersonnelHint: 'Invitations can only be sent to people who already exist in Personnel.',
        selectPersonnel: 'Personnel',
        personnel: 'Personnel',
        invitePersonRequired: 'Select a person from Personnel.',
        inviteEmailTitle: 'Email required',
        inviteEmailSubtitle: 'Enter an email address for {{name}}. It will be saved on their personnel record.',
        linkPersonnel: 'Link to personnel',
        unlinkPersonnel: 'Unlink',
        linkedPersonnel: 'Personnel',
        linkPersonnelSubtitle: 'Choose a personnel record to link to {{email}}. Only unlinked records with matching or empty email are shown.',
        linkPersonnelSuccess: 'Member linked to personnel.',
        linkPersonnelFailed: 'Could not link member to personnel.',
        unlinkPersonnelSuccess: 'Personnel link removed.',
        unlinkPersonnelFailed: 'Could not remove personnel link.',
      },
      account: {
        title: 'Account',
        currentPassword: 'Current password',
        newPassword: 'New password',
        changePassword: 'Change password',
        passwordChanged: 'Password changed successfully.',
        passwordChangeFailed: 'Could not change password.',
        mustChangePassword: 'You must change your password before continuing.',
      },
      permissions: {
        groups: {
          organisation: 'Organisation',
          companies: 'Companies',
          personnel: 'Personnel',
          projects: 'Projects',
          costSheets: 'Cost sheets',
          siteLogistics: 'Site logistics',
          warehouse: 'Warehouse',
          tools: 'Tools',
          materials: 'Materials',
          dailyWork: 'Daily work',
          workerHoursReport: 'Work hours report',
          myHours: 'My hours',
          writeOffs: 'Write-offs',
          generalTasks: 'General tasks',
          finance: 'Finance',
        },
        keys: {
          orgUsersManage: 'Manage users',
          orgUsersRemove: 'Remove users',
          orgInvitesManage: 'Manage invites',
          companiesRead: 'View companies',
          companiesWrite: 'Edit companies',
          personnelRead: 'View personnel',
          personnelWrite: 'Edit personnel',
          projectsRead: 'View projects',
          projectsWrite: 'Edit projects',
          costSheetsRead: 'View cost sheets',
          costSheetsWrite: 'Edit cost sheets',
          siteLogisticsRead: 'View site logistics',
          siteLogisticsWrite: 'Edit site logistics',
          warehouseRead: 'View warehouse',
          warehouseWrite: 'Edit warehouse',
          toolsRead: 'View tools',
          toolsWrite: 'Edit tools',
          materialsRead: 'View materials',
          materialsWrite: 'Edit materials',
          dailyWorkRead: 'View daily work',
          dailyWorkWrite: 'Edit daily work',
          dailyWorkCostSheetMappingRead: 'View daily work cost sheet mapping',
          dailyWorkCostSheetMappingWrite: 'Edit daily work cost sheet mapping',
          workerHoursReportRead: 'View work hours report',
          myHoursRead: 'View my hours',
          writeOffsRead: 'View write-offs',
          writeOffsWrite: 'Edit write-offs',
          generalTasksRead: 'View general tasks',
          generalTasksWrite: 'Edit general tasks',
          financeQuotesRead: 'View quotes',
          financeQuotesWrite: 'Edit quotes',
          financeDeliveriesRead: 'View delivery notes',
          financeDeliveriesWrite: 'Edit delivery notes',
          financeInvoicesRead: 'View invoices',
          financeInvoicesWrite: 'Edit invoices',
          financePricesRead: 'View finance prices',
        },
      },
      nav: {
        dashboard: 'Dashboard',
        companies: 'Companies',
        projects: 'Projects',
        generalTasks: 'General Tasks',
        personnel: 'Personnel',
        dueDates: 'Due Dates',
        finance: 'Financial documents',
        tools: 'Tools',
        warehouse: 'Warehouse',
        siteDelivery: 'Site Delivery',
        siteDeparture: 'Site Departure',
        costSheets: 'Cost Sheets',
        dailyWorkInput: 'Daily Work Input',
        dailyWorkCostSheetMapping: 'Daily work mapping',
        workerHoursReport: 'Work Hours Report',
        myHours: 'My Hours',
        workQuantities: 'Work Quantities',
        projectExpenses: 'Project Expenses',
        projectTimelines: 'Project Timelines',
        writeOffs: 'Write-offs',
        users: 'Users',
        account: 'Account',
      },
      status: {
        notStarted: 'Not Started',
        inProgress: 'In Progress',
        done: 'Done',
      },
      dashboard: {
        title: 'Dashboard',
        totalCompanies: 'Total Companies',
        totalProjects: 'Total Projects',
        activeProjects: 'Active Projects',
        registeredCompanies: 'Registered companies',
        allProjects: 'All projects',
        projectsInProgress: 'Projects in progress',
        projectStatusDistribution: 'Project Status Distribution',
        projectsByMonth: 'Projects by Month',
        projects: 'Projects',
      },
      dueDates: {
        title: 'Due Dates',
        filters: {
          all: 'All',
          personnel: 'Personnel',
          machines: 'Machines',
          projects: 'Projects',
          finance: 'Finance',
        },
        summary: {
          late: 'Late',
          thisMonth: 'This month',
          nextMonth: 'Next month',
          total: 'Total',
        },
        columns: {
          expirationDate: 'Expiry date',
          source: 'Source',
          name: 'Name',
          item: 'Item',
          category: 'Category',
          status: 'Status',
        },
        sources: {
          personnel: 'Personnel',
          machine: 'Machine',
          project: 'Project',
          financeQuote: 'Quote',
          financeInvoice: 'Invoice',
          financeDelivery: 'Delivery',
        },
        status: {
          late: 'Late',
          thisMonth: 'This month',
          nextMonth: 'Next month',
          later: 'Later',
        },
        empty: 'No due dates found',
      },
      finance: {
        date: 'Date',
        number: 'Number',
        partner: 'Partner',
        client: 'Client',
        directCost: 'Direct cost',
        indirectCost: 'Indirect cost',
        deliveryDate: 'Delivery date',
        lines: 'Lines',
        allocated: 'Allocated',
        deliveredWhere: 'Delivered where',
        noDeliveriesYet: 'No receipts on linked delivery notes yet',
        receiptsBySite: 'Receipts by site',
        viewOriginal: 'View / download original',
        changeStatus: 'Change document status',
        archiveConfirm: 'Archive this document?',
        linesRequiredError: 'Enter at least one line from the document.',
        steps: {
          direction: 'Direction',
          category: 'Category',
          paper: 'Document data',
          lines: 'Lines',
          links: 'Links',
        },
        hints: {
          direction: 'Is this an incoming supplier invoice or an outgoing invoice to a client?',
          category: 'Choose the accounting category for this invoice.',
          paper: 'Enter what is written on the document.',
          linesRequired: 'Enter every line from the document. At least one line is required. A project is optional.',
          links: 'Optional. Link this document to a quote, delivery note or invoice.',
        },
        clientHint: 'Name of the client this invoice is billed to. This is not a Companies partner record.',
        workQuantitySuggestions: 'Suggest lines from Work Quantities',
        noWorkQuantities: 'No work quantities for this project. You can still add custom lines.',
        amount: 'Amount',
        status: 'Status',
        search: 'Search',
        project: 'Project',
        all: 'All',
        new: 'New',
        settings: 'Settings',
        types: { QUOTE: 'Quotes', DELIVERY_NOTE: 'Delivery notes', INVOICE: 'Invoices' },
        quoteStatus: { DRAFT: 'Draft', ACTIVE: 'Active', ACCEPTED: 'Accepted / ordered', REJECTED: 'Rejected', CANCELLED: 'Cancelled', CLOSED: 'Closed' },
        originalRequired: 'Original document is required for invoices',
        basics: 'Basic information',
        stepErrors: {
          direction: 'Select whether this invoice is incoming or outgoing.',
          category: 'Select a category before continuing.',
          partner: 'Enter the partner name.',
          client: 'Enter the client name.',
          date: 'Enter the document date.',
          dueDate: 'Enter the due date.',
          total: 'Enter the total amount.',
        },
        duplicateWarning: 'A similar document already exists',
        confirmUnassigned: 'Confirm that this is not related to a project',
        saveFailed: 'Could not save document',
        invoiceStep: 'Step {{step}} of 3',
        direction: 'Direction',
        incoming: 'Incoming',
        outgoing: 'Outgoing',
        category: 'Category',
        subcategory: 'Subcategory',
        suggestAddCompany: 'This partner is not in Companies yet. You can add it there after saving.',
        validUntil: 'Valid until',
        total: 'Total',
        receivedAt: 'Received at',
        dueDate: 'Due date',
        paid: 'Paid',
        notProjectRelated: 'Not related to a project',
        none: 'None',
        warehouse: 'Warehouse',
        warehouseHint: 'Allocate this document to the organisation warehouse instead of a project (e.g. stock for later use).',
        notProjectRelatedHint: 'Use this only when the cost or income is not for a construction site, such as office overhead. The system will not save a project-related invoice with an empty project by accident.',
        quoteLeadDaysHint: 'On Due Dates, warn this many days before a quote expires.',
        invoiceLeadDaysHint: 'On Due Dates, warn this many days before an invoice is due.',
        linkDocument: 'Link to another document',
        linkType: 'Document type',
        findDocument: 'Search by number, partner or description',
        linkNow: 'Link selected document',
        addLine: 'Add line',
        description: 'Description',
        quantity: 'Quantity',
        unit: 'Unit',
        original: 'Original PDF or image',
        linkHint: 'Find existing quotes, delivery notes or invoices to connect. You can link more than one.',
        back: 'Back',
        next: 'Next',
        saveAnyway: 'Save anyway',
        expired: 'Expired',
        payment: 'Payment',
        unallocated: 'Unallocated',
        remaining: 'remaining',
        related: 'Related documents',
        markPaid: 'Mark paid',
        markUnpaid: 'Mark unpaid',
        addReceipt: 'Add receipt',
        lineTotalDiscountTitle: 'Possible discount',
        lineTotalDiscountBody: 'Line total is {{lineSum}}, document total is {{docTotal}}. That is a {{percent}}% difference. Is this a discount?',
        lineTotalMismatchTitle: 'Amounts do not match',
        lineTotalMismatchBody: 'Line total is {{lineSum}}, document total is {{docTotal}}. This looks like missing lines or a typing error.',
        confirmDiscount: 'This is a discount',
        continueMismatch: 'Continue anyway',
        fixLines: 'Fix lines',
        archive: 'Archive',
        audit: 'Audit log',
        documentQty: 'Qty on document',
        receivedQty: 'Qty received',
        quoteLeadDays: 'Quote reminder days',
        invoiceLeadDays: 'Invoice reminder days',
        categories: 'Categories',
        addCategory: 'Add category',
        inactive: 'inactive',
        deactivate: 'Deactivate',
        activate: 'Activate',
        name: 'Name',
        tooltip: 'Tooltip',
        parent: 'Parent category',
        expectsProject: 'Expects a project',
        warnIfUnassigned: 'Warn if not project-related',
      },
      companies: {
        title: 'Companies',
        addCompany: 'Add Company',
        editCompany: 'Edit Company',
        deleteConfirm: 'Are you sure you want to delete this company?',
        fields: {
          id: 'ID',
          name: 'Name',
          companyName: 'Company Name',
          address: 'Address',
          oib: 'OIB',
          email: 'Email',
          phone: 'Phone',
          website: 'Website',
          notes: 'Notes',
          directors: 'Directors',
          ibans: 'IBANs',
          directorName: 'Director Name',
          ibanNameDescription: 'IBAN Name/Description',
          ibanNumber: 'IBAN Number',
        },
        addDirector: 'Add Director',
        addIban: 'Add IBAN',
        ibanCount: '{{count}} IBAN(s)',
        ibanPlaceholder: 'e.g., Main Account, Secondary Account',
      },
      generalTasks: {
        title: 'General Tasks',
        addTask: 'Add general task',
        editTask: 'Edit general task',
        deleteConfirm: 'Are you sure you want to delete this general task?',
        systemSection: 'System general tasks',
        orgSection: 'Organisation general tasks',
        filterByCategory: 'Filter by category',
        filterBySource: 'Filter by source',
        allCategories: 'All categories',
        allSources: 'All sources',
        sourceSystem: 'System',
        sourceCreated: 'Created',
        emptySection: 'No general tasks match the current filters.',
        systemBadge: 'System',
        categoryFreeSoloHint: 'Pick an existing category or type a new one',
        fields: {
          id: 'ID',
          name: 'Name',
          category: 'Category',
          description: 'Description',
          source: 'Source',
        },
      },
      projects: {
        title: 'Projects',
        addProject: 'Add Project',
        editProject: 'Edit Project',
        deleteConfirm: 'Are you sure you want to delete this project?',
        noSupervisors: 'No supervisors',
        legacyValue: '(legacy value)',
        fields: {
          id: 'ID',
          name: 'Name',
          projectName: 'Project Name',
          investor: 'Investor',
          location: 'Location',
          supervisors: 'Supervisors',
          startDate: 'Start Date',
          endDate: 'End Date',
          status: 'Status',
          mainContractor: 'Main Contractor',
          workType: 'Work Type',
          projectPhase: 'Project Phase',
          phase: 'Phase',
          agreedPrice: 'Agreed Price',
          agreedPriceEur: 'Agreed Price (EUR)',
          notes: 'Notes',
          supervisingField: 'Supervising Field',
          supervisorCompany: 'Supervisor Company',
          supervisorName: 'Supervisor Name',
        },
        addSupervisor: 'Add Supervisor',
        supervisingFieldPlaceholder: 'e.g., Construction, Electrical, Roof',
      },
      personnel: {
        title: 'Personnel',
        addPerson: 'Add Person',
        editPerson: 'Edit Person',
        personDetails: 'Person Details',
        contact: 'Contact',
        tabs: {
          info: 'Info',
          hours: 'Hours',
          absences: 'Absences',
          files: 'Files',
        },
        fields: {
          id: 'ID',
          firstName: 'First Name',
          lastName: 'Last Name',
          nickname: 'Nickname',
          email: 'Email',
          phone: 'Phone / mobile',
          company: 'Company',
          role: 'Role',
          workVisaDate: 'Work Visa Date',
          notes: 'Notes',
          date: 'Date',
          hours: 'Hours',
          project: 'Project',
          type: 'Type',
          start: 'Start',
          end: 'End',
          startDate: 'Start Date',
          endDate: 'End Date',
          expirationDateOptional: 'Expiration date (optional)',
          newCategory: 'New category',
        },
        linkedUser: 'Linked user account',
        absence: {
          vacation: 'Vacation',
          sickLeave: 'Sick leave',
        },
        files: {
          globalCategories: 'Global File Categories',
          uploadFile: 'Upload file',
          noFilesInCategory: 'No files uploaded for this person in this category.',
          uploadedAt: 'Uploaded',
          expires: 'Expires',
          fileLabel: 'File',
          selectExpiration: 'Select expiration date for file upload.',
        },
      },
      gantt: {
        name: 'Name',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
        projectTimeline: 'Project Timeline',
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
        noDataTitle: 'No timeline data available',
        noDataBody: 'Complete the timeline wizard to create phases and tasks for the Gantt chart.',
        refreshData: 'Refresh Data',
        failedToLoad: 'Failed to load timeline data',
        failedToUpdateDate: 'Failed to update task date',
        tooltipPartOfTask: 'Part of task',
        tooltipStart: 'Start',
        tooltipEnd: 'End',
        tooltipDuration: 'Duration',
        tooltipDays: 'days',
        tooltipProgress: 'Progress',
      },
      siteDelivery: {
        title: 'Site Delivery',
        deliveries: 'Deliveries',
        addNew: 'Add new',
        addNewDelivery: 'Add new delivery',
        source: 'Source',
        fromWarehouse: 'From warehouse',
        fromMerchant: 'From merchant',
        project: 'Project',
        date: 'Date',
        amount: 'Amount',
        material: 'Material',
        assignedItem: 'Assigned Item',
        deliveryNotes: 'Delivery notes',
        materialName: 'Material name',
        materialNotes: 'Material notes',
        receiptAttachment: 'Receipt/Dispatch Note (image/pdf)',
        financeDoc: 'Document on hand',
        financeDelivery: 'Delivery note',
        financeInvoice: 'Invoice',
        financeBoth: 'Delivery note and invoice',
        partner: 'Supplier',
        documentNumber: 'Document number',
        unitPrice: 'Unit price',
        paidAtRegister: 'Paid at checkout',
        items: 'Items',
        addItem: 'Add item',
        deliveryNoteNumber: 'Delivery note number',
        invoiceNumber: 'Invoice number',
        deliveryNoteAttachment: 'Delivery note PDF/image',
        invoiceAttachment: 'Invoice PDF/image',
        save: 'Save',
        failedCreate: 'Failed to create site delivery.',
        receivedOnlyHint: 'Enter only quantities received on this site. The same delivery note can be used on multiple sites.',
        findExistingNote: 'Find existing delivery note',
        findExistingNoteHint: 'Search by number or partner. Leave empty to create a new delivery note.',
        duplicateWarning: 'A similar delivery note or invoice already exists. You can attach this delivery to it, or save a new document.',
        useExisting: 'Use this document',
        saveAnyway: 'Save as new document',
        deleteConfirm: 'Are you sure you want to delete this delivery?',
        empty: 'No deliveries for this site yet.',
      },
      siteStock: {
        title: 'On-site stock',
        empty: 'No items currently on this site.',
      },
      siteDeparture: {
        title: 'Site Departure',
        departures: 'Departures',
        addDeparture: 'Add departure',
        returnHint: 'This returns items from the site to the warehouse. It is not a purchase and does not create a delivery note or invoice.',
        project: 'Project',
        date: 'Date',
        assignedItem: 'Assigned Item',
        amount: 'Amount',
        qtyDelivered: 'qty delivered',
        reason: 'Departure reason',
        deleteConfirm: 'Are you sure you want to delete this departure?',
        empty: 'No departures for this site yet.',
      },
      projectTimelines: {
        title: 'Project Timelines',
        selectProject: 'Select Project',
        failedLoadProjects: 'Failed to load projects',
        failedLoadTimeline: 'Failed to load timeline',
        failedDeleteTimeline: 'Failed to delete timeline',
        noProjectSelectedTitle: 'Select a project to view or create its timeline',
        noProjectSelectedBody: 'Choose a project from the dropdown above to get started.',
        noTimelineTitle: 'No timeline created for this project',
        noTimelineBody: 'Create a project timeline to plan and track your construction phases, work groups, floors, and tasks.',
        createTimeline: 'Create Timeline',
        projectTimeline: 'Project Timeline',
        created: 'Created',
        editTimeline: 'Edit Timeline',
        deleteTimeline: 'Delete Timeline',
        view: 'View',
        generalView: 'General View',
        detailedView: 'Detailed View',
        detailedHint: 'Cost sheets linked to tasks are shown',
        panHint: 'Scroll horizontally or click-and-drag on the timeline chart to pan',
        deleteDialogTitle: 'Delete Timeline',
        deleteDialogBody: 'Are you sure you want to delete the timeline for "{{projectName}}"? This action cannot be undone and will remove all phases, tasks, and dependencies.',
      },
      writeOffs: {
        title: 'Write-offs',
        add: 'Add Write-off',
        edit: 'Edit Write-off',
        view: 'Write-off Details',
        deleteConfirm: 'Are you sure you want to delete this write-off?',
        failedFetch: 'Failed to fetch write-offs',
        failedDelete: 'Failed to delete write-off',
        failedSave: 'Failed to save write-off',
        itemType: 'Item type',
        item: 'Item',
        quantity: 'Quantity',
        reason: 'Reason for write-off',
        writeOffBy: 'Write-off by',
        writeOffDate: 'Write-off date',
        viewDetails: 'View details',
        stockInWarehouse: '{{qty}} {{unit}} in warehouse',
      },
      costSheetsPage: {
        title: 'Cost Sheets',
        selectProject: 'Select Project',
        add: 'Add Cost Sheet',
        edit: 'Edit Cost Sheet',
        deleteConfirm: 'Are you sure you want to delete this cost sheet?',
        uncategorized: 'Uncategorized',
        category: 'Category',
        categoryFallbackHint: 'No categories yet — a Manual entries category will be created automatically.',
        code: 'Code',
        quantity: 'Quantity',
        unit: 'Unit',
        unitPrice: 'Unit Price',
        totalPrice: 'Total Price',
        projectPreselected: 'Project is pre-selected based on your selection above',
        perDocument: 'Per document',
        allGroup: 'All',
        manualEntries: 'Manual entries',
        sourceDocument: 'Source',
        selectDocument: 'Select document',
        itemCount: '{{count}} items',
        uploadedAt: 'Uploaded',
        documentNotes: 'Document notes',
        selectWorksheet: 'Worksheet',
        allWorksheets: 'All worksheets',
        sourceSheet: 'Worksheet',
      },
      dailyWorkInput: {
        steps: {
          generalInfoWorkers: 'General info and workers',
          tasksPeopleMaterials: 'Tasks, people and materials',
          locationPinPhotos: 'Location pin and photos',
        },
        existingEntriesForDate: 'Existing entries for this date',
        totalHours: 'Total hours',
        rainDay: 'Rain day',
        calendarDotsExplanation: 'Red = step 1 · Yellow = steps 1 and 2 · Green = steps 1, 2 and 3',
        addPerson: 'Add person',
        addSubcontractorWorker: 'Add subcontractor worker',
        duplicateMostRecentInput: 'Duplicate most recent input',
        saveAndContinue: 'Save and continue',
        submitDailyWork: 'Submit daily work',
        startTime: 'From',
        endTime: 'Till',
        setFrom: 'Set from',
        setTo: 'Set to',
        lunch: 'Lunch',
        workerNote: 'Note',
        addNote: 'Add note',
        taskNote: 'Task note (optional)',
        rainDisableLunchPrompt: 'Disable lunch for all workers for this day?',
        rainDisableLunch: 'Disable lunch',
        rainKeepLunch: 'Keep lunch',
        step2: {
          title: 'Tasks — work assignment',
          subtitle: 'Tasks are optional. Assigning people and materials is also optional.',
          addTask: 'Add task',
          allTasksAlreadyUsed: 'All tasks already have work rows for this date or are in the editor',
          noGeneralTasks: 'No general tasks are available in the catalog.',
          removeTaskFromEditor: 'Remove this task from today\'s editor',
          people: 'People',
          peopleOnTask: 'People on task',
          addPerson: 'Add Person',
          addSubcontractor: 'Add Subcontractor',
          taskUsesAllWorkers: 'This task already uses all workers from step 1.',
          noPeopleInStep1: 'No people selected in step 1',
          existing: '(existing)',
          manDays: 'Man-days',
          materialsEquipment: 'Materials/Equipment',
          addMaterialEquipment: 'Add Material/Equipment',
          equipment: 'Equipment',
          unknownMaterial: 'Unknown Material',
          ourEquipment: 'our equipment',
          subcontractorEquipment: 'subcontractor equipment',
          equipmentType: 'Equipment Type',
          ourEquipmentLabel: 'Our Equipment',
          subcontractorEquipmentLabel: 'Subcontractor Equipment',
          item: 'Item',
          equipmentName: 'Equipment Name',
          noTasksInEditor: 'No tasks in the editor. Click \"Add task\" or save to continue without tasks.',
          assignedWorkers: 'Assigned workers',
          missingAssignments: 'Missing assignments',
          unassignedWorkers: 'Not assigned to a task',
          peopleOptionalHint: 'Assigning workers to tasks is optional.',
          chooseGeneralTask: 'Choose a general task to enter people and materials for:',
          chooseCategoryFirst: 'First select a category, then choose a general task.',
          chooseCategoryOrTask: 'Select a category, or add a new one. Then pick a task, add a new task, or save the category only if the exact task is unknown.',
          selectCategoryHint: 'Select a category to see available general tasks.',
          pickCategoryTitle: '1. Select a category',
          pickSubcategoryTitle: '2. Select a subcategory in {{category}}',
          changeCategory: 'Change',
          nextToSubcategory: 'Next',
          backToCategories: 'Back',
          categoryNotOnList: 'Category is not on the list',
          subcategories: 'Subcategories',
          noSubcategories: 'No subcategories. Add a new one or use the category only.',
          addNewSubcategory: 'Add a new subcategory',
          searchCategories: 'Search categories',
          noMatchingCategories: 'No matching categories.',
          newCategory: 'New category',
          addCategory: 'Add',
          useCategoryOnly: 'Use this category only',
          categoryAlreadyAdded: 'This category is already added for today',
          tasksInCategory: 'Tasks in this category',
          newTaskName: 'New subcategory',
          addNewTask: 'Add',
          unspecifiedTask: 'task unspecified',
          addAtLeastOneTask: 'Add at least one task before continuing.',
          couldNotAddTask: 'Could not add general task to this date.',
          noMaterialsDelivered: 'No materials have been delivered to this project yet.',
          uncategorized: 'No category (legacy)',
          noTasksInCategory: 'No available tasks in this category.',
          noTasksAvailableToAdd: 'No tasks available to add. All catalog tasks already have rows for this date.',
        },
        step3: {
          title: 'Task location pin and photos',
          subtitle: 'Pins and photos are optional. For each task you can select object and floor, put a pin on the floorplan, then upload work photos.',
          clickFloorplanToPlacePin: 'Click on the floorplan to place a pin',
          addFloorplan: 'Add floorplan',
          floorplanN: 'Floorplan',
          object: 'Object',
          floor: 'Floor',
          selectedFloor: 'Selected floor',
          noFloorplanFile: 'Selected floor has no floorplan file. Upload it in Project Details -> Floorplans.',
          pins: 'Pins',
          pinN: 'Pin',
          deletePin: 'Delete pin',
          uploadPictures: 'Upload picture(s)',
          photosCount: 'photo(s)',
          photosForPin: 'Photos for this pin',
          unassignedPhotos: 'Photos without a pin',
          noTasksInEditor: 'No tasks for this date. You can submit without pins or photos.',
          zoomIn: 'Zoom in',
          zoomOut: 'Zoom out',
          resetZoom: 'Reset',
        },
        edited: 'Edited',
        duplicateStep1Hint: ' This will populate Step 1 with the same people (workers) from the most recent input.',
        duplicateStep2Hint: ' This will populate Step 2 with the same task assignments and materials from the most recent input.',
        peopleToBeAddedStep1: 'People that will be added to Step 1:',
        tasksPopulatedStep2: 'Tasks that will be populated in Step 2:',
        applyDuplicate: 'Apply Duplicate',
        subcontractorCompany: 'Subcontractor company',
      },
      dailyWorkCostSheetMapping: {
        title: 'Daily Work Cost Sheet Mapping',
        selectProject: 'Select project',
        selectDate: 'Selected date',
        noTasksForDate: 'No daily work entries for this date.',
        connectSection: 'Connect with original cost sheets',
        addCostSheet: 'Add original cost sheet',
        saveMapping: 'Save mapping',
        saveSuccess: 'Mapping saved successfully.',
        calendarDotsExplanation: 'Red = daily work not mapped · Green = mapped and saved',
        mappingRequired: 'Every general task must have at least one cost sheet before saving.',
        people: 'People',
        materials: 'Materials / equipment',
        pinsAndPhotos: 'Floorplan pins and photos',
        noPinsOrPhotos: 'No floorplan pins or photos for this task.',
        modal: {
          tabLinked: 'Cost sheets linked to this general task',
          tabAll: 'All cost sheets for this project',
          selectCostSheet: 'Select cost sheet',
          confirm: 'Add',
          noLinkedCostSheets: 'No cost sheets are linked to this general task in project settings.',
        },
      },
      workerHoursReport: {
        title: 'Work Hours Report',
        subtitle: 'Hours from daily work Step 1 only (general info and workers).',
        tabByWorker: 'By worker',
        tabByProject: 'By project',
        fromDate: 'From',
        toDate: 'To',
        worker: 'Worker',
        project: 'Project',
        allProjects: 'All projects',
        runReport: 'Run report',
        totalHours: 'Total hours',
        byProject: 'By project',
        dailyBreakdown: 'Daily breakdown',
        projectName: 'Project',
        hours: 'Hours',
        date: 'Date',
        name: 'Name',
        type: 'Type',
        typePerson: 'Person',
        typeSubcontractor: 'Subcontractor company',
        noData: 'No hours found for the selected filters.',
        invalidDateRange: 'End date must be on or after start date.',
        selectWorker: 'Select a worker',
        selectProject: 'Select a project',
        expandDaily: 'Show daily hours',
        collapseDaily: 'Hide daily hours',
        expandHistory: 'Show change history',
        collapseHistory: 'Hide change history',
        changeHistory: 'Change history',
        lunchUsed: 'Lunch used',
        lunchReduced: 'Lunch (−{{hours}} h)',
      },
      myHours: {
        title: 'My Hours',
        subtitle: 'Your recorded work hours from daily work input. Expand a row to see who entered or changed it.',
        previousMonth: 'Previous month',
        nextMonth: 'Next month',
        totalHours: 'Total hours',
        date: 'Date',
        project: 'Project',
        hours: 'Hours',
        noData: 'No hours recorded for this month.',
        notLinked: 'Your account is not linked to a personnel record. Ask an administrator to link your user in Users.',
        noPermission: 'You do not have permission to view this page.',
        changeHistory: 'Change history',
        expandHistory: 'Show change history',
        collapseHistory: 'Hide change history',
      },
      personnelHoursHistory: {
        loading: 'Loading history…',
        noHistory: 'No changes recorded.',
        unknownUser: 'Unknown user',
        byUser: '{{user}} · {{date}}',
        yes: 'Yes',
        no: 'No',
        created: 'Entry created',
        createdHours: 'Created — {{hours}} h',
        deleted: 'Entry deleted',
        deletedWasHours: 'Deleted — was {{hours}} h',
        updated: 'Entry updated',
        hoursChanged: 'Hours: {{from}} → {{to}}',
        rainDaySet: 'Rain day: {{value}}',
        rainDayChanged: 'Rain day: {{from}} → {{to}}',
        notesChanged: 'Notes updated',
        notesSet: 'Note added',
        timeRangeSet: 'Time {{from}}–{{to}}',
        timeRangeChanged: 'Time {{fromStart}}–{{fromEnd}} → {{toStart}}–{{toEnd}}',
        lunchSet: 'Lunch: {{value}}',
        lunchChanged: 'Lunch {{from}} → {{to}}',
        lunchReductionSet: 'Lunch reduction: {{hours}} h',
        lunchReductionChanged: 'Lunch reduction {{from}} → {{to}} h',
        hasEdits: 'This entry was edited after it was first saved',
      },
      projectDetails: {
        tabs: {
          overview: 'Overview',
          deadlineUpdates: 'Deadline Updates',
          costSheets: 'Cost Sheets',
          generalTasks: 'General Tasks',
          resources: 'Resources',
          personnel: 'Personnel',
          floorplans: 'Floorplans',
          otherDocuments: 'Other documents',
        },
        projectDetails: 'Project Details',
        updateDeadline: 'Update Deadline',
        newEndDate: 'New End Date',
        noPreviousDate: 'No previous date',
        note: 'Note',
        saveUpdate: 'Save Update',
        updatedDate: 'Updated Date',
        previousDate: 'Previous Date',
        updatedAt: 'Updated At',
        itemType: 'Item Type',
        noCostSheets: 'No cost sheets found. Upload an Excel file to get started.',
        linkCostSheets: 'Link cost sheets',
        linkSelected: 'Link selected',
        daysLate: 'days late',
        daysRemaining: 'days remaining',
        itemCount: '{{count}} items',
        uploadedAt: 'Uploaded',
        downloadDocument: 'Download',
        downloadDocumentFailed: 'Failed to download document',
        downloadNotAvailable: 'No file available to download',
        deleteDocument: 'Delete document',
        deleteDocumentConfirm: 'Delete this document and all {{count}} linked cost sheet entries? This cannot be undone.',
        deleteDocumentBlocked: 'Cannot delete document because some cost sheets have work quantities or expenses linked.',
        manualEntries: 'Manual entries',
        expand: 'Show items',
        collapse: 'Hide items',
        costSheetCoverage: 'Cost sheet coverage',
        unassignedCostSheets: '{{count}} cost sheet(s) not assigned to any task',
        noCostSheetsYet: 'No cost sheets in this project yet.',
        newTaskName: 'New task name',
        addTask: 'Add task',
        addExistingGeneralTask: 'Add existing general task',
        createNewGeneralTask: 'Create new general task',
        categoryFreeSoloHint: 'Pick an existing category or type a new one',
        createAndAssign: 'Create and assign',
        selectExistingTask: 'Select existing general task',
        addSelectedTask: 'Add selected',
        quickCreateHint: 'Or type a new name to create and assign',
        editTaskName: 'Edit task name',
        linkedPositions: '{{count}} linked positions',
        showCostSheets: 'Show cost sheets',
        hideCostSheets: 'Hide cost sheets',
        deleteTaskConfirm: 'Remove this task from the project? Cost sheet links will be removed. The catalog task is kept.',
        noGeneralTasks: 'No general tasks on this project yet. Add an existing one or create a new general task.',
        allCostSheetsAssigned: 'All cost sheets are already assigned to a task.',
        noCatalogTasksAvailable: 'All catalog tasks are already on this project.',
        searchCostSheets: 'Search cost sheets',
        searchByCodeOrName: 'Search by code or name',
        sortCodeAsc: 'Code A→Z',
        sortCodeDesc: 'Code Z→A',
        selectAllInList: 'Select all in list ({{count}})',
        noCostSheetsMatch: 'No cost sheets match your search.',
        toolName: 'Tool Name',
        assignedTo: 'Assigned To',
        materialType: 'Material Type',
        deliveryDate: 'Delivery Date',
        projectPersonnel: 'Project Personnel',
        totalHours: 'Total Hours',
        objectName: 'Object name',
        floors: 'Floors',
        addObject: 'Add object',
        floorNumber: 'Floor {{number}}',
        floorNamePlaceholder: 'Name (e.g. Basement)',
        noFileUploaded: 'No file uploaded for this floor.',
        otherDocuments: {
          addDocument: 'Add document',
          name: 'Name',
          notes: 'Notes',
          file: 'Document',
          selectFile: 'Select file',
          noDocuments: 'No documents uploaded yet.',
          previewFailed: 'Failed to preview document',
          downloadFailed: 'Failed to download document',
          deleteConfirm: 'Delete this document? This cannot be undone.',
          uploading: 'Uploading...',
        },
      },
      costSheetUpload: {
        pleaseUploadExcel: 'Please upload an Excel (.xlsx) file',
        uploadFailed: 'Failed to upload file. Please try again.',
        uploading: 'Uploading and processing cost sheets...',
        dropHere: 'Drop the file here',
        dragAndDrop: 'Drag and drop an Excel file here, or click to select',
        onlyXlsx: 'Only .xlsx files are accepted',
        createdResult: 'Created {{costSheets}} cost sheets and {{categories}} categories.',
        importWarnings: 'Import warnings:',
      },
      tools: {
        addTool: 'Add Tool',
        editTool: 'Edit Tool',
        assign: 'Assign',
        assignments: 'Assignments',
        currentAssignments: 'Current Assignments',
        newAssignment: 'New Assignment',
        assignTool: 'Assign Tool',
        noNotes: 'No notes',
        fields: {
          type: 'Type',
          serialNumber: 'Serial Number',
          dateReceived: 'Date Received',
          dateReturned: 'Date Returned',
          serial: 'Serial',
        },
      },
      materials: {
        fields: {
          registration: 'Registration',
          registrationDate: 'Registration Date',
        },
      },
      warehouse: {
        tabs: {
          inventory: 'Inventory',
          templates: 'Templates',
        },
        sections: {
          materials: 'Materials',
          machines: 'Machines',
          equipment: 'Equipment',
          tools: 'Tools',
        },
        templates: {
          machineTemplates: 'Machine Templates',
        },
        addMaterial: 'Add material',
        addMachine: 'Add machine',
        addEquipment: 'Add equipment',
        inboundTitle: 'Warehouse inbound',
        inboundMode: 'Inbound type',
        inboundOpening: 'Opening / existing stock (no document)',
        inboundPurchase: 'From supplier (with document)',
        inboundOpeningHint: 'Use this for stock you already have when starting the app. No delivery note or invoice is created.',
        inboundPurchaseHint: 'Enter only quantities received into the warehouse. The same delivery note can also be used on sites.',
        inboundFailed: 'Could not save warehouse inbound.',
        itemCategory: { Material: 'Material', Equipment: 'Equipment', Machine: 'Machine', Tool: 'Tool' },
        addMachineTemplate: 'Add Machine Template',
        editMachineTemplate: 'Edit Machine Template',
        machineTemplate: 'Machine Template',
        deleteMachineTemplateConfirm: 'Are you sure you want to delete this machine template?',
        errorDeletingMachineTemplate: 'Error deleting machine template',
        errorSavingMachineTemplate: 'Error saving machine template',
        customFields: 'Custom fields',
        addField: 'Add field',
        fieldName: 'Field name',
        fieldType: 'Field type',
        required: 'Required',
        optional: 'Optional',
        dueDateExpires: 'Due date (expires)',
        machineFiles: 'Machine files',
        assignTemplateForFiles: 'Assign a template to this machine before managing files.',
        noFilesInCategory: 'No files uploaded for this machine in this category.',
        fieldOptions: 'Options',
        fieldOptionsHint: 'One option per line',
        noTemplate: 'No template',
        fieldCount: '{{count}} fields',
        moveFieldUp: 'Move field up',
        moveFieldDown: 'Move field down',
        deleteField: 'Delete field',
        requiredFieldsMissing: 'Fill in all required template fields',
        selectOptionsRequired: 'Dropdown fields need at least one option',
        fieldTypes: {
          text: 'Text',
          date: 'Date',
          number: 'Number',
          select: 'Dropdown',
        },
      },
      dates: {
        increaseByDay: 'Increase date by 1 day',
        decreaseByDay: 'Decrease date by 1 day',
        months: [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December',
        ],
        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        calendarAria: 'Calendar for {{month}} {{year}}. Select a date.',
      },
    },
  },
  hr: {
    translation: {
      app: {
        name: 'CCA-App',
        language: 'Jezik',
        navigationMenu: 'Navigacijski izbornik',
        activeOrganisation: 'Organizacija',
      },
      common: {
        add: 'Dodaj',
        edit: 'Uredi',
        delete: 'Obriši',
        details: 'Detalji',
        save: 'Spremi',
        cancel: 'Odustani',
        close: 'Zatvori',
        retry: 'Pokušaj ponovno',
        refresh: 'Osvježi',
        create: 'Kreiraj',
        rename: 'Preimenuj',
        upload: 'Prenesi',
        open: 'Otvori',
        noData: 'Nema podataka',
        optional: 'Neobavezno',
        actions: 'Akcije',
        loading: 'Učitavanje...',
        notSet: 'Nije postavljeno',
        remove: 'Ukloni',
        description: 'Opis',
        replace: 'Zamijeni',
        preview: 'Pregled',
        updateDueDate: 'Ažuriraj rok',
        turnOffDueDate: 'Isključi rok',
        dueDate: 'Rok',
        notes: 'Bilješke',
        updateNotes: 'Ažuriraj bilješke',
      },
      auth: {
        loginTitle: 'Prijava',
        loginSubtitle: 'Prijavite se računom svoje organizacije za pristup ConstAdminu.',
        email: 'E-pošta',
        password: 'Lozinka',
        confirmPassword: 'Potvrdi lozinku',
        signIn: 'Prijavi se',
        signOut: 'Odjavi se',
        loginFailed: 'Prijava nije uspjela. Provjerite e-poštu i lozinku.',
        forgotPassword: 'Zaboravili ste lozinku?',
        forgotPasswordTitle: 'Resetirajte lozinku',
        forgotPasswordSubtitle: 'Unesite e-poštu računa i poslat ćemo vam poveznicu za novu lozinku.',
        forgotPasswordSent: 'Ako račun postoji za tu e-poštu, uskoro ćete primiti upute za reset lozinke.',
        forgotPasswordFailed: 'Reset lozinke nije mogao biti pokrenut. Pokušajte ponovno.',
        sendResetLink: 'Pošalji poveznicu',
        resetUrlDevHint: 'E-pošta je isključena — koristite ovu poveznicu:',
        resetPasswordTitle: 'Odaberite novu lozinku',
        resetPasswordSubtitle: 'Unesite novu lozinku za svoj račun.',
        resetPassword: 'Resetiraj lozinku',
        newPassword: 'Nova lozinka',
        passwordResetSuccess: 'Lozinka je ažurirana. Preusmjeravanje na prijavu...',
        passwordResetFailed: 'Lozinka nije mogla biti resetirana. Poveznica je možda istekla.',
        backToSignIn: 'Natrag na prijavu',
        inviteTitle: 'Prihvati pozivnicu',
        inviteSubtitle: 'Postavite lozinku za pridruživanje organizaciji.',
        acceptInvite: 'Prihvati pozivnicu',
        inviteAccepted: 'Pozivnica je prihvaćena za {{email}}. Preusmjeravanje na prijavu...',
        inviteFailed: 'Pozivnica nije mogla biti prihvaćena.',
        passwordMismatch: 'Lozinke se ne podudaraju.',
      },
      users: {
        title: 'Korisnici i pozivnice',
        inviteUser: 'Pozovi korisnika',
        members: 'Članovi',
        pendingInvites: 'Aktivne pozivnice',
        role: 'Uloga',
        sendInvite: 'Pošalji pozivnicu',
        revoke: 'Opozovi',
        expiresAt: 'Istječe',
        adminOnly: 'Samo administratori organizacije i platforme mogu pristupiti ovoj stranici.',
        loadFailed: 'Korisnici se nisu mogli učitati.',
        inviteFailed: 'Pozivnica nije mogla biti kreirana.',
        revokeFailed: 'Pozivnica nije mogla biti opozvana.',
        inviteCreated: 'Pozivnica je kreirana. Podijelite ovu poveznicu: {{url}}',
        inviteSent: 'Pozivnica je poslana na {{email}}.',
        inviteEmailFailed: 'E-pošta s pozivnicom nije mogla biti poslana. Pokušajte ponovno.',
        organisationSettings: 'Postavke organizacije',
        organisationName: 'Naziv organizacije',
        organisationSlug: 'Slug (neobavezno)',
        organisationSlugHint: 'Za URL-ove; ostavite prazno ako nije potrebno.',
        organisationSaved: 'Organizacija je ažurirana.',
        organisationSaveFailed: 'Organizacija nije mogla biti ažurirana.',
        dailyWorkHoursFormat: 'Format radnih sati u dnevnom unosu',
        dailyWorkHoursFormatHours: 'Broj sati',
        dailyWorkHoursFormatTimeRange: 'Vremenski raspon (od–do)',
        defaultWorkStartTime: 'Zadani radni sati od',
        defaultWorkEndTime: 'Zadani radni sati do',
        lunchDurationMinutes: 'Trajanje pauze za ručak (minute)',
        lunchIsPartOfWorkHours: 'Ručak se računa u radno vrijeme',
        defaultUsedLunch: 'Ručak uključen po zadanom',
        editEmail: 'Uredi e-poštu',
        emailSaved: 'E-pošta je ažurirana.',
        emailSaveFailed: 'E-pošta nije mogla biti ažurirana.',
        platformOrganisations: 'Platform organizacije',
        platformOrganisationsHint: 'Upravljanje nazivima organizacija na platformi.',
        selectOrganisation: 'Organizacija',
        createOrganisation: 'Nova organizacija',
        organisationCreateFailed: 'Organizacija nije mogla biti kreirana.',
        joinAsAdmin: 'Pridruži se kao admin',
        joinedOrganisation: 'Sada ste admin ove organizacije. Prebacite se na nju u izborniku.',
        joinFailed: 'Pridruživanje organizaciji nije uspjelo.',
        rolesTab: 'Uloge',
        createRole: 'Nova uloga',
        editRole: 'Uredi ulogu',
        roleName: 'Naziv uloge',
        roleSaved: 'Uloga je spremljena.',
        roleSaveFailed: 'Uloga nije mogla biti spremljena.',
        roleUpdated: 'Uloga korisnika je ažurirana.',
        roleUpdateFailed: 'Uloga korisnika nije mogla biti ažurirana.',
        removeMember: 'Ukloni',
        removeMemberConfirm: 'Ukloniti {{email}} iz ove organizacije? Račun za prijavu bit će obrisan ako korisnik ne pripada drugoj organizaciji.',
        memberRemoved: 'Korisnik je uklonjen iz organizacije.',
        memberRemovedAccountDeleted: 'Korisnik je uklonjen i njegov račun je obrisan.',
        memberRemoveFailed: 'Korisnik nije mogao biti uklonjen.',
        projectsUpdated: 'Dodjela projekata je ažurirana.',
        projectsUpdateFailed: 'Dodjela projekata nije mogla biti ažurirana.',
        assignedProjects: 'Dodijeljeni projekti',
        allProjects: 'Svi projekti',
        projects: 'Projekti',
        type: 'Vrsta',
        adminRole: 'Administrator',
        systemRole: 'Sustav',
        customRole: 'Prilagođeno',
        viewPermissions: 'Pregled dozvola',
        invitePersonnelHint: 'Pozivnice se mogu slati samo osobama koje već postoje u Djelatnicima.',
        selectPersonnel: 'Djelatnik',
        personnel: 'Djelatnik',
        invitePersonRequired: 'Odaberite osobu iz Djelatnika.',
        inviteEmailTitle: 'Potrebna e-pošta',
        inviteEmailSubtitle: 'Unesite e-poštu za {{name}}. Bit će spremljena na zapis djelatnika.',
        linkPersonnel: 'Poveži s djelatnikom',
        unlinkPersonnel: 'Ukloni poveznicu',
        linkedPersonnel: 'Djelatnik',
        linkPersonnelSubtitle: 'Odaberite zapis djelatnika za povezivanje s {{email}}. Prikazani su samo nepovezani zapisi s istom ili praznom e-poštom.',
        linkPersonnelSuccess: 'Korisnik je povezan s djelatnikom.',
        linkPersonnelFailed: 'Korisnik nije mogao biti povezan s djelatnikom.',
        unlinkPersonnelSuccess: 'Poveznica s djelatnikom je uklonjena.',
        unlinkPersonnelFailed: 'Poveznica s djelatnikom nije mogla biti uklonjena.',
      },
      account: {
        title: 'Račun',
        currentPassword: 'Trenutna lozinka',
        newPassword: 'Nova lozinka',
        changePassword: 'Promijeni lozinku',
        passwordChanged: 'Lozinka je promijenjena.',
        passwordChangeFailed: 'Lozinka nije mogla biti promijenjena.',
        mustChangePassword: 'Morate promijeniti lozinku prije nastavka.',
      },
      permissions: {
        groups: {
          organisation: 'Organizacija',
          companies: 'Tvrtke',
          personnel: 'Djelatnici',
          projects: 'Projekti',
          costSheets: 'Troškovnici',
          siteLogistics: 'Logistika gradilišta',
          warehouse: 'Skladište',
          tools: 'Alati',
          materials: 'Materijali',
          dailyWork: 'Dnevni unos rada',
          workerHoursReport: 'Izvještaj radnih sati',
          myHours: 'Moji sati',
          writeOffs: 'Otpisi',
          generalTasks: 'Opći zadaci',
          finance: 'Financije',
        },
        keys: {
          orgUsersManage: 'Upravljanje korisnicima',
          orgUsersRemove: 'Uklanjanje korisnika',
          orgInvitesManage: 'Upravljanje pozivnicama',
          companiesRead: 'Pregled tvrtki',
          companiesWrite: 'Uređivanje tvrtki',
          personnelRead: 'Pregled djelatnika',
          personnelWrite: 'Uređivanje djelatnika',
          projectsRead: 'Pregled projekata',
          projectsWrite: 'Uređivanje projekata',
          costSheetsRead: 'Pregled troškovnika',
          costSheetsWrite: 'Uređivanje troškovnika',
          siteLogisticsRead: 'Pregled logistike',
          siteLogisticsWrite: 'Uređivanje logistike',
          warehouseRead: 'Pregled skladišta',
          warehouseWrite: 'Uređivanje skladišta',
          toolsRead: 'Pregled alata',
          toolsWrite: 'Uređivanje alata',
          materialsRead: 'Pregled materijala',
          materialsWrite: 'Uređivanje materijala',
          dailyWorkRead: 'Pregled dnevnog rada',
          dailyWorkWrite: 'Uređivanje dnevnog rada',
          dailyWorkCostSheetMappingRead: 'Pregled povezivanja dnevnog rada sa stavkama',
          dailyWorkCostSheetMappingWrite: 'Uređivanje povezivanja dnevnog rada sa stavkama',
          workerHoursReportRead: 'Pregled izvještaja radnih sati',
          myHoursRead: 'Pregled mojih sati',
          writeOffsRead: 'Pregled otpisa',
          writeOffsWrite: 'Uređivanje otpisa',
          generalTasksRead: 'Pregled općih zadataka',
          generalTasksWrite: 'Uređivanje općih zadataka',
          financeQuotesRead: 'Pregled ponuda',
          financeQuotesWrite: 'Uređivanje ponuda',
          financeDeliveriesRead: 'Pregled otpremnica',
          financeDeliveriesWrite: 'Uređivanje otpremnica',
          financeInvoicesRead: 'Pregled računa',
          financeInvoicesWrite: 'Uređivanje računa',
          financePricesRead: 'Pregled financijskih cijena',
        },
      },
      nav: {
        dashboard: 'Nadzorna ploča',
        companies: 'Tvrtke',
        projects: 'Projekti',
        generalTasks: 'Opći zadaci',
        personnel: 'Djelatnici',
        dueDates: 'Rokovi',
        finance: 'Financijski dokumenti',
        tools: 'Alati',
        warehouse: 'Skladište',
        siteDelivery: 'Dostava na gradilište',
        siteDeparture: 'Otprema s gradilišta',
        costSheets: 'Troškovnici',
        dailyWorkInput: 'Dnevni unos rada',
        dailyWorkCostSheetMapping: 'Povezivanje dnevnog rada',
        workerHoursReport: 'Izvještaj radnih sati',
        myHours: 'Moji sati',
        workQuantities: 'Količine radova',
        projectExpenses: 'Troškovi projekta',
        projectTimelines: 'Vremenski planovi projekta',
        writeOffs: 'Otpisi',
        users: 'Korisnici',
        account: 'Račun',
      },
      status: {
        notStarted: 'Nije započeto',
        inProgress: 'U tijeku',
        done: 'Završeno',
      },
      dashboard: {
        title: 'Nadzorna ploča',
        totalCompanies: 'Ukupno tvrtki',
        totalProjects: 'Ukupno projekata',
        activeProjects: 'Aktivni projekti',
        registeredCompanies: 'Registrirane tvrtke',
        allProjects: 'Svi projekti',
        projectsInProgress: 'Projekti u tijeku',
        projectStatusDistribution: 'Raspodjela statusa projekata',
        projectsByMonth: 'Projekti po mjesecima',
        projects: 'Projekti',
      },
      dueDates: {
        title: 'Rokovi',
        filters: {
          all: 'Sve',
          personnel: 'Djelatnici',
          machines: 'Strojevi',
          projects: 'Projekti',
          finance: 'Financije',
        },
        summary: {
          late: 'Isteklo',
          thisMonth: 'Ovaj mjesec',
          nextMonth: 'Sljedeći mjesec',
          total: 'Ukupno',
        },
        columns: {
          expirationDate: 'Datum isteka',
          source: 'Izvor',
          name: 'Naziv',
          item: 'Stavka',
          category: 'Kategorija',
          status: 'Status',
        },
        sources: {
          personnel: 'Djelatnik',
          machine: 'Stroj',
          project: 'Projekt',
          financeQuote: 'Ponuda',
          financeInvoice: 'Račun',
          financeDelivery: 'Otpremnica',
        },
        status: {
          late: 'Isteklo',
          thisMonth: 'Ovaj mjesec',
          nextMonth: 'Sljedeći mjesec',
          later: 'Kasnije',
        },
        empty: 'Nema rokova',
      },
      finance: {
        date: 'Datum',
        number: 'Broj',
        partner: 'Partner',
        client: 'Klijent',
        directCost: 'Direktni trošak',
        indirectCost: 'Indirektni trošak',
        deliveryDate: 'Datum isporuke',
        lines: 'Stavke',
        allocated: 'Raspoređeno',
        deliveredWhere: 'Što je dostavljeno i gdje',
        noDeliveriesYet: 'Na povezanim otpremnicama još nema primitaka',
        receiptsBySite: 'Primitci po gradilištu',
        viewOriginal: 'Pregledaj / preuzmi original',
        changeStatus: 'Promijeni status dokumenta',
        archiveConfirm: 'Arhivirati ovaj dokument?',
        linesRequiredError: 'Unesite barem jednu stavku s dokumenta.',
        steps: {
          direction: 'Smjer',
          category: 'Kategorija',
          paper: 'Podaci s dokumenta',
          lines: 'Stavke',
          links: 'Povezivanje',
        },
        hints: {
          direction: 'Ulazni račun dobavljača ili izlazni račun klijentu?',
          category: 'Odaberite knjigovodstvenu kategoriju računa.',
          paper: 'Unesite što piše na dokumentu.',
          linesRequired: 'Unesite sve stavke s dokumenta. Minimalno jedna. Projekt nije obavezan.',
          links: 'Nije obavezno. Spojite ovaj dokument s ponudom, otpremnicom ili računom.',
        },
        clientHint: 'Naziv klijenta kojem ispostavljate račun. Ne spaja se s registrom Tvrtki.',
        workQuantitySuggestions: 'Predloži stavke iz Količina radova',
        noWorkQuantities: 'Nema količina radova za ovaj projekt. I dalje možete dodati vlastite stavke.',
        amount: 'Iznos',
        status: 'Status',
        search: 'Pretraga',
        project: 'Projekt',
        all: 'Sve',
        new: 'Novo',
        settings: 'Postavke',
        types: { QUOTE: 'Ponude', DELIVERY_NOTE: 'Otpremnice', INVOICE: 'Računi' },
        quoteStatus: { DRAFT: 'Skica', ACTIVE: 'Aktivna', ACCEPTED: 'Prihvaćena / naručeno', REJECTED: 'Odbijena', CANCELLED: 'Otkazana', CLOSED: 'Zatvorena' },
        originalRequired: 'Original je obavezan za račun',
        basics: 'Osnovne informacije',
        stepErrors: {
          direction: 'Odaberite je li račun ulazni ili izlazni.',
          category: 'Odaberite kategoriju prije nastavka.',
          partner: 'Unesite naziv partnera.',
          client: 'Unesite naziv klijenta.',
          date: 'Unesite datum dokumenta.',
          dueDate: 'Unesite datum dospijeća.',
          total: 'Unesite ukupan iznos.',
        },
        duplicateWarning: 'Sličan dokument već postoji',
        confirmUnassigned: 'Potvrdite da dokument nije vezan za projekt',
        saveFailed: 'Dokument nije spremljen',
        invoiceStep: 'Korak {{step}} od 3',
        direction: 'Smjer',
        incoming: 'Ulazni',
        outgoing: 'Izlazni',
        category: 'Kategorija',
        subcategory: 'Podkategorija',
        suggestAddCompany: 'Ovaj partner još nije u Tvrtkama. Možete ga dodati nakon spremanja.',
        validUntil: 'Vrijedi do',
        total: 'Ukupno',
        receivedAt: 'Datum primitka',
        dueDate: 'Datum dospijeća',
        paid: 'Plaćeno',
        notProjectRelated: 'Nije vezano za gradilište',
        none: 'Nema',
        warehouse: 'Skladište',
        warehouseHint: 'Rasporedite dokument na središnje skladište umjesto na projekt (npr. materijal za kasniju upotrebu).',
        notProjectRelatedHint: 'Koristite samo kada trošak ili prihod nije za gradilište, npr. uredske režije. Sustav neće slučajno spremiti projektni račun bez projekta.',
        quoteLeadDaysHint: 'Na Rokovima upozori ovoliko dana prije isteka ponude.',
        invoiceLeadDaysHint: 'Na Rokovima upozori ovoliko dana prije dospijeća računa.',
        linkDocument: 'Poveži s drugim dokumentom',
        linkType: 'Vrsta dokumenta',
        findDocument: 'Traži po broju, partneru ili opisu',
        linkNow: 'Poveži odabrani dokument',
        addLine: 'Dodaj stavku',
        description: 'Opis',
        quantity: 'Količina',
        unit: 'Jedinica',
        original: 'Original PDF ili slika',
        linkHint: 'Pronađite postojeće ponude, otpremnice ili račune. Možete povezati više dokumenata.',
        back: 'Natrag',
        next: 'Dalje',
        saveAnyway: 'Ipak spremi',
        expired: 'Istekla',
        payment: 'Plaćanje',
        unallocated: 'Neraspoređeno',
        remaining: 'preostalo',
        related: 'Povezani dokumenti',
        markPaid: 'Označi plaćeno',
        markUnpaid: 'Označi neplaćeno',
        addReceipt: 'Dodaj primitak',
        lineTotalDiscountTitle: 'Mogući popust',
        lineTotalDiscountBody: 'Zbroj stavki je {{lineSum}}, ukupni iznos dokumenta {{docTotal}}. Razlika je {{percent}}%. Radi li se o popustu?',
        lineTotalMismatchTitle: 'Iznosi se ne podudaraju',
        lineTotalMismatchBody: 'Zbroj stavki je {{lineSum}}, ukupni iznos dokumenta {{docTotal}}. To izgleda kao greška ili nedostajuće stavke.',
        confirmDiscount: 'To je popust',
        continueMismatch: 'Svejedno nastavi',
        fixLines: 'Ispravi stavke',
        archive: 'Arhiviraj',
        audit: 'Povijest',
        documentQty: 'Količina na dokumentu',
        receivedQty: 'Zaprimljena količina',
        quoteLeadDays: 'Dani upozorenja za ponude',
        invoiceLeadDays: 'Dani upozorenja za račune',
        categories: 'Kategorije',
        addCategory: 'Dodaj kategoriju',
        inactive: 'neaktivno',
        deactivate: 'Deaktiviraj',
        activate: 'Aktiviraj',
        name: 'Naziv',
        tooltip: 'Tooltip',
        parent: 'Nadkategorija',
        expectsProject: 'Očekuje projekt',
        warnIfUnassigned: 'Upozori ako nije vezano za projekt',
      },
      companies: {
        title: 'Tvrtke',
        addCompany: 'Dodaj tvrtku',
        editCompany: 'Uredi tvrtku',
        deleteConfirm: 'Jeste li sigurni da želite obrisati ovu tvrtku?',
        fields: {
          id: 'ID',
          name: 'Naziv',
          companyName: 'Naziv tvrtke',
          address: 'Adresa',
          oib: 'OIB',
          email: 'E-pošta',
          phone: 'Telefon',
          website: 'Web stranica',
          notes: 'Bilješke',
          directors: 'Direktori',
          ibans: 'IBAN-i',
          directorName: 'Ime direktora',
          ibanNameDescription: 'Naziv/opis IBAN-a',
          ibanNumber: 'IBAN broj',
        },
        addDirector: 'Dodaj direktora',
        addIban: 'Dodaj IBAN',
        ibanCount: '{{count}} IBAN',
        ibanPlaceholder: 'npr. Glavni račun, sekundarni račun',
      },
      generalTasks: {
        title: 'Opći zadaci',
        addTask: 'Dodaj opći zadatak',
        editTask: 'Uredi opći zadatak',
        deleteConfirm: 'Jeste li sigurni da želite obrisati ovaj opći zadatak?',
        systemSection: 'Sustavski opći zadaci',
        orgSection: 'Opći zadaci organizacije',
        filterByCategory: 'Filtriraj po kategoriji',
        filterBySource: 'Filtriraj po izvoru',
        allCategories: 'Sve kategorije',
        allSources: 'Svi izvori',
        sourceSystem: 'Sustav',
        sourceCreated: 'Kreirano',
        emptySection: 'Nema općih zadataka koji odgovaraju trenutnim filterima.',
        systemBadge: 'Sustav',
        categoryFreeSoloHint: 'Odaberite postojeću kategoriju ili unesite novu',
        fields: {
          id: 'ID',
          name: 'Naziv',
          category: 'Kategorija',
          description: 'Opis',
          source: 'Izvor',
        },
      },
      projects: {
        title: 'Projekti',
        addProject: 'Dodaj projekt',
        editProject: 'Uredi projekt',
        deleteConfirm: 'Jeste li sigurni da želite obrisati ovaj projekt?',
        noSupervisors: 'Nema nadzora',
        legacyValue: '(stara vrijednost)',
        fields: {
          id: 'ID',
          name: 'Naziv',
          projectName: 'Naziv projekta',
          investor: 'Investitor',
          location: 'Lokacija',
          supervisors: 'Nadzor',
          startDate: 'Početni datum',
          endDate: 'Završni datum',
          status: 'Status',
          mainContractor: 'Glavni izvođač',
          workType: 'Vrsta radova',
          projectPhase: 'Faza projekta',
          phase: 'Faza',
          agreedPrice: 'Ugovorena cijena',
          agreedPriceEur: 'Ugovorena cijena (EUR)',
          notes: 'Bilješke',
          supervisingField: 'Područje nadzora',
          supervisorCompany: 'Tvrtka nadzora',
          supervisorName: 'Ime nadzornika',
        },
        addSupervisor: 'Dodaj nadzor',
        supervisingFieldPlaceholder: 'npr. građevina, elektro, krov',
      },
      personnel: {
        title: 'Djelatnici',
        addPerson: 'Dodaj djelatnika',
        editPerson: 'Uredi djelatnika',
        personDetails: 'Detalji djelatnika',
        contact: 'Kontakt',
        tabs: {
          info: 'Info',
          hours: 'Sati',
          absences: 'Izostanci',
          files: 'Datoteke',
        },
        fields: {
          id: 'ID',
          firstName: 'Ime',
          lastName: 'Prezime',
          nickname: 'Nadimak',
          email: 'E-pošta',
          phone: 'Telefon / mobitel',
          company: 'Tvrtka',
          role: 'Uloga',
          workVisaDate: 'Datum radne dozvole',
          notes: 'Bilješke',
          date: 'Datum',
          hours: 'Sati',
          project: 'Projekt',
          type: 'Vrsta',
          start: 'Početak',
          end: 'Kraj',
          startDate: 'Početni datum',
          endDate: 'Završni datum',
          expirationDateOptional: 'Datum isteka (neobavezno)',
          newCategory: 'Nova kategorija',
        },
        linkedUser: 'Povezani korisnički račun',
        absence: {
          vacation: 'Godišnji',
          sickLeave: 'Bolovanje',
        },
        files: {
          globalCategories: 'Globalne kategorije datoteka',
          uploadFile: 'Prenesi datoteku',
          noFilesInCategory: 'Nema prenesenih datoteka za ovu osobu u ovoj kategoriji.',
          uploadedAt: 'Preneseno',
          expires: 'Istječe',
          fileLabel: 'Datoteka',
          selectExpiration: 'Odaberite datum isteka za prijenos datoteke.',
        },
      },
      gantt: {
        name: 'Naziv',
        day: 'Dan',
        week: 'Tjedan',
        month: 'Mjesec',
        year: 'Godina',
        projectTimeline: 'Vremenski plan projekta',
        zoomIn: 'Uvećaj',
        zoomOut: 'Umanji',
        noDataTitle: 'Nema dostupnih podataka vremenskog plana',
        noDataBody: 'Dovršite čarobnjak vremenskog plana kako biste kreirali faze i zadatke za Gantt graf.',
        refreshData: 'Osvježi podatke',
        failedToLoad: 'Neuspjelo učitavanje podataka vremenskog plana',
        failedToUpdateDate: 'Neuspjelo ažuriranje datuma zadatka',
        tooltipPartOfTask: 'Dio zadatka',
        tooltipStart: 'Početak',
        tooltipEnd: 'Kraj',
        tooltipDuration: 'Trajanje',
        tooltipDays: 'dana',
        tooltipProgress: 'Napredak',
      },
      siteDelivery: {
        title: 'Dostava na gradilište',
        deliveries: 'Dostave',
        addNew: 'Dodaj novo',
        addNewDelivery: 'Dodaj novu dostavu',
        source: 'Izvor',
        fromWarehouse: 'Iz skladišta',
        fromMerchant: 'Od dobavljača',
        project: 'Projekt',
        date: 'Datum',
        amount: 'Količina',
        material: 'Materijal',
        assignedItem: 'Dodijeljena stavka',
        deliveryNotes: 'Bilješke dostave',
        materialName: 'Naziv materijala',
        materialNotes: 'Bilješke materijala',
        receiptAttachment: 'Račun/otpremnica (slika/pdf)',
        financeDoc: 'Dokument u ruci',
        financeDelivery: 'Otpremnica',
        financeInvoice: 'Račun',
        financeBoth: 'Otpremnica i račun',
        partner: 'Dobavljač',
        documentNumber: 'Broj dokumenta',
        unitPrice: 'Jedinična cijena',
        paidAtRegister: 'Plaćeno na blagajni',
        items: 'Stavke',
        addItem: 'Dodaj stavku',
        deliveryNoteNumber: 'Broj otpremnice',
        invoiceNumber: 'Broj računa',
        deliveryNoteAttachment: 'PDF/slika otpremnice',
        invoiceAttachment: 'PDF/slika računa',
        save: 'Spremi',
        failedCreate: 'Neuspjelo kreiranje dostave na gradilište.',
        receivedOnlyHint: 'Unesite samo količine primljene na ovom gradilištu. Ista otpremnica može se koristiti na više gradilišta.',
        findExistingNote: 'Pronađi postojeću otpremnicu',
        findExistingNoteHint: 'Traži po broju ili partneru. Prazno polje znači novu otpremnicu.',
        duplicateWarning: 'Slična otpremnica ili račun već postoji. Možete spojiti ovu dostavu s postojećim dokumentom ili spremiti novi.',
        useExisting: 'Koristi ovaj dokument',
        saveAnyway: 'Spremi kao novi dokument',
        deleteConfirm: 'Jeste li sigurni da želite obrisati ovu dostavu?',
        empty: 'Još nema dostava na ovo gradilište.',
      },
      siteStock: {
        title: 'Stanje skladišta na gradilištu',
        empty: 'Na ovom gradilištu trenutno nema stavki.',
      },
      siteDeparture: {
        title: 'Otprema s gradilišta',
        departures: 'Otpreme',
        addDeparture: 'Dodaj otpremu',
        returnHint: 'Ovo vraća stavke sa gradilišta na skladište. Nije nabava i ne kreira otpremnicu niti račun.',
        project: 'Projekt',
        date: 'Datum',
        assignedItem: 'Dodijeljena stavka',
        amount: 'Količina',
        qtyDelivered: 'isporučena kol.',
        reason: 'Razlog otpremanja',
        deleteConfirm: 'Jeste li sigurni da želite obrisati ovu otpremu?',
        empty: 'Još nema otprema s ovog gradilišta.',
      },
      projectTimelines: {
        title: 'Vremenski planovi projekta',
        selectProject: 'Odaberi projekt',
        failedLoadProjects: 'Neuspjelo učitavanje projekata',
        failedLoadTimeline: 'Neuspjelo učitavanje vremenskog plana',
        failedDeleteTimeline: 'Neuspjelo brisanje vremenskog plana',
        noProjectSelectedTitle: 'Odaberite projekt za pregled ili izradu vremenskog plana',
        noProjectSelectedBody: 'Odaberite projekt iz izbornika iznad za početak.',
        noTimelineTitle: 'Nema kreiranog vremenskog plana za ovaj projekt',
        noTimelineBody: 'Kreirajte vremenski plan projekta za planiranje i praćenje faza, radnih grupa, etaža i zadataka.',
        createTimeline: 'Kreiraj vremenski plan',
        projectTimeline: 'Vremenski plan projekta',
        created: 'Kreirano',
        editTimeline: 'Uredi vremenski plan',
        deleteTimeline: 'Obriši vremenski plan',
        view: 'Prikaz',
        generalView: 'Opći prikaz',
        detailedView: 'Detaljni prikaz',
        detailedHint: 'Prikazani su troškovnici povezani sa zadacima',
        panHint: 'Pomaknite vodoravno ili kliknite i povucite po vremenskoj osi za pomicanje',
        deleteDialogTitle: 'Obriši vremenski plan',
        deleteDialogBody: 'Jeste li sigurni da želite obrisati vremenski plan za "{{projectName}}"? Ova radnja je nepovratna i uklonit će sve faze, zadatke i ovisnosti.',
      },
      writeOffs: {
        title: 'Otpisi',
        add: 'Dodaj otpis',
        edit: 'Uredi otpis',
        view: 'Detalji otpisa',
        deleteConfirm: 'Jeste li sigurni da želite obrisati ovaj otpis?',
        failedFetch: 'Neuspjelo dohvaćanje otpisa',
        failedDelete: 'Neuspjelo brisanje otpisa',
        failedSave: 'Neuspjelo spremanje otpisa',
        itemType: 'Vrsta stavke',
        item: 'Stavka',
        quantity: 'Količina',
        reason: 'Razlog otpisa',
        writeOffBy: 'Otpisao',
        writeOffDate: 'Datum otpisa',
        viewDetails: 'Detalji',
        stockInWarehouse: '{{qty}} {{unit}} na skladištu',
      },
      costSheetsPage: {
        title: 'Troškovnici',
        selectProject: 'Odaberi projekt',
        add: 'Dodaj troškovnik',
        edit: 'Uredi troškovnik',
        deleteConfirm: 'Jeste li sigurni da želite obrisati ovaj troškovnik?',
        uncategorized: 'Bez kategorije',
        category: 'Kategorija',
        categoryFallbackHint: 'Još nema kategorija — automatski će se stvoriti kategorija Ručni unosi.',
        code: 'Šifra',
        quantity: 'Količina',
        unit: 'Jedinica',
        unitPrice: 'Jedinična cijena',
        totalPrice: 'Ukupna cijena',
        projectPreselected: 'Projekt je unaprijed odabran prema izboru iznad',
        perDocument: 'Po dokumentu',
        allGroup: 'Svi',
        manualEntries: 'Ručni unosi',
        sourceDocument: 'Izvor',
        selectDocument: 'Odaberi dokument',
        itemCount: '{{count}} stavki',
        uploadedAt: 'Učitano',
        documentNotes: 'Bilješke dokumenta',
        selectWorksheet: 'Radni list',
        allWorksheets: 'Svi radni listovi',
        sourceSheet: 'Radni list',
      },
      dailyWorkInput: {
        steps: {
          generalInfoWorkers: 'Opći podaci i radnici',
          tasksPeopleMaterials: 'Zadaci, ljudi i materijali',
          locationPinPhotos: 'Lokacija, pin i fotografije',
        },
        existingEntriesForDate: 'Postojeći unosi za ovaj datum',
        totalHours: 'Ukupno sati',
        rainDay: 'Kišni dan',
        calendarDotsExplanation: 'Crveno = korak 1 · Žuto = koraci 1 i 2 · Zeleno = koraci 1, 2 i 3',
        addPerson: 'Dodaj osobu',
        addSubcontractorWorker: 'Dodaj kooperantskog radnika',
        duplicateMostRecentInput: 'Dupliciraj zadnji unos',
        saveAndContinue: 'Spremi i nastavi',
        submitDailyWork: 'Pošalji dnevni unos rada',
        startTime: 'Od',
        endTime: 'Do',
        setFrom: 'Postavi od',
        setTo: 'Postavi do',
        lunch: 'Ručak',
        workerNote: 'Bilješka',
        addNote: 'Dodaj bilješku',
        taskNote: 'Bilješka zadatka (neobavezno)',
        rainDisableLunchPrompt: 'Isključiti ručak za sve radnike za ovaj dan?',
        rainDisableLunch: 'Isključi ručak',
        rainKeepLunch: 'Zadrži ručak',
        step2: {
          title: 'Zadaci — raspodjela rada',
          subtitle: 'Zadaci nisu obavezni. Dodjela ljudi i materijala također nije obavezna.',
          addTask: 'Dodaj zadatak',
          allTasksAlreadyUsed: 'Svi zadaci već imaju redove rada za ovaj datum ili su u uređivaču',
          noGeneralTasks: 'Nema dostupnih općih zadataka u katalogu.',
          removeTaskFromEditor: 'Ukloni ovaj zadatak iz današnjeg uređivača',
          people: 'Ljudi',
          peopleOnTask: 'Ljudi na zadatku',
          addPerson: 'Dodaj osobu',
          addSubcontractor: 'Dodaj kooperanta',
          taskUsesAllWorkers: 'Ovaj zadatak već koristi sve radnike iz koraka 1.',
          noPeopleInStep1: 'Nema odabranih ljudi u koraku 1',
          existing: '(postojeće)',
          manDays: 'Čovjek-dani',
          materialsEquipment: 'Materijali/Oprema',
          addMaterialEquipment: 'Dodaj materijal/opremu',
          equipment: 'Oprema',
          unknownMaterial: 'Nepoznat materijal',
          ourEquipment: 'naša oprema',
          subcontractorEquipment: 'kooperantska oprema',
          equipmentType: 'Vrsta opreme',
          ourEquipmentLabel: 'Naša oprema',
          subcontractorEquipmentLabel: 'Kooperantska oprema',
          item: 'Stavka',
          equipmentName: 'Naziv opreme',
          noTasksInEditor: 'Još nema zadataka u uređivaču. Kliknite \"Dodaj zadatak\" ili spremite da nastavite bez zadataka.',
          assignedWorkers: 'Dodijeljeni radnici',
          missingAssignments: 'Nedostaju dodjele',
          unassignedWorkers: 'Nisu dodijeljeni zadatku',
          peopleOptionalHint: 'Dodjela radnika zadacima nije obavezna.',
          chooseGeneralTask: 'Odaberite opći zadatak za unos ljudi i materijala:',
          chooseCategoryFirst: 'Prvo odaberite kategoriju, zatim opći zadatak.',
          chooseCategoryOrTask: 'Odaberite kategoriju ili dodajte novu. Zatim odaberite zadatak, dodajte novi zadatak ili spremite samo kategoriju ako točan zadatak nije poznat.',
          selectCategoryHint: 'Odaberite kategoriju da vidite dostupne opće zadatke.',
          pickCategoryTitle: '1. Odaberite kategoriju',
          pickSubcategoryTitle: '2. Odaberite podkategoriju u kategoriji {{category}}',
          changeCategory: 'Promijeni',
          nextToSubcategory: 'Dalje',
          backToCategories: 'Natrag',
          categoryNotOnList: 'Kategorije nema na listi',
          subcategories: 'Podkategorije',
          noSubcategories: 'Nema podkategorija. Dodajte novu ili koristite samo kategoriju.',
          addNewSubcategory: 'Dodaj novu podkategoriju',
          searchCategories: 'Pretraži kategorije',
          noMatchingCategories: 'Nema odgovarajućih kategorija.',
          newCategory: 'Nova kategorija',
          addCategory: 'Dodaj',
          useCategoryOnly: 'Koristi samo ovu kategoriju',
          categoryAlreadyAdded: 'Ova kategorija je već dodana za danas',
          tasksInCategory: 'Zadaci u ovoj kategoriji',
          newTaskName: 'Nova podkategorija',
          addNewTask: 'Dodaj',
          unspecifiedTask: 'zadatak nije naveden',
          addAtLeastOneTask: 'Dodajte barem jedan zadatak prije nastavka.',
          couldNotAddTask: 'Nije moguće dodati opći zadatak za ovaj datum.',
          noMaterialsDelivered: 'Na ovaj projekt još nije isporučen nijedan materijal.',
          uncategorized: 'Bez kategorije (naslijeđeno)',
          noTasksInCategory: 'Nema dostupnih zadataka u ovoj kategoriji.',
          noTasksAvailableToAdd: 'Nema dostupnih zadataka za dodavanje. Svi zadaci iz kataloga već imaju redove za ovaj datum.',
        },
        step3: {
          title: 'Pin lokacije zadatka i fotografije',
          subtitle: 'Pinovi i fotografije nisu obavezni. Za svaki zadatak možete odabrati objekt i kat, postaviti pin na tlocrt, zatim učitati fotografije rada.',
          clickFloorplanToPlacePin: 'Kliknite na tlocrt za postavljanje pina',
          addFloorplan: 'Dodaj tlocrt',
          floorplanN: 'Tlocrt',
          object: 'Objekt',
          floor: 'Kat',
          selectedFloor: 'Odabrani kat',
          noFloorplanFile: 'Odabrani kat nema datoteku tlocrta. Učitajte je u Projekt Detalji -> Tlocrti.',
          pins: 'Pinovi',
          pinN: 'Pin',
          deletePin: 'Obriši pin',
          uploadPictures: 'Učitaj slike',
          photosCount: 'slika',
          photosForPin: 'Fotografije za ovaj pin',
          unassignedPhotos: 'Fotografije bez pina',
          noTasksInEditor: 'Nema zadataka za ovaj datum. Možete poslati unos bez pinova ili fotografija.',
          zoomIn: 'Povećaj',
          zoomOut: 'Smanji',
          resetZoom: 'Resetiraj',
        },
        edited: 'Uređeno',
        duplicateStep1Hint: ' Ovo će popuniti Korak 1 istim ljudima (radnicima) iz posljednjeg unosa.',
        duplicateStep2Hint: ' Ovo će popuniti Korak 2 istim dodjelama zadataka i materijalima iz posljednjeg unosa.',
        peopleToBeAddedStep1: 'Ljudi koji će biti dodani u Korak 1:',
        tasksPopulatedStep2: 'Zadaci koji će biti popunjeni u Koraku 2:',
        applyDuplicate: 'Primijeni dupliciranje',
        subcontractorCompany: 'Kooperantska tvrtka',
      },
      dailyWorkCostSheetMapping: {
        title: 'Povezivanje dnevnog rada sa stavkama',
        selectProject: 'Odaberi projekt',
        selectDate: 'Odabrani datum',
        noTasksForDate: 'Nema unosa dnevnog rada za ovaj datum.',
        connectSection: 'Spoji sa orginalnim stavkama',
        addCostSheet: 'Dodaj originalnu stavku',
        saveMapping: 'Spremi povezivanje',
        saveSuccess: 'Povezivanje je uspješno spremljeno.',
        calendarDotsExplanation: 'Crveno = dnevni rad nije povezan · Zeleno = povezano i spremljeno',
        mappingRequired: 'Svaki opći zadatak mora imati barem jednu stavku prije spremanja.',
        people: 'Ljudi',
        materials: 'Materijali / oprema',
        pinsAndPhotos: 'Označene lokacije i fotografije',
        noPinsOrPhotos: 'Nema označenih lokacija ili fotografija za ovaj zadatak.',
        modal: {
          tabLinked: 'Stavke povezane sa ovom općom stavkom',
          tabAll: 'Sve stavke za ovaj projekt',
          selectCostSheet: 'Odaberi stavku',
          confirm: 'Dodaj',
          noLinkedCostSheets: 'Nema stavki povezanih s ovim općim zadatkom u postavkama projekta.',
        },
      },
      workerHoursReport: {
        title: 'Izvještaj radnih sati',
        subtitle: 'Sati samo iz koraka 1 dnevnog unosa rada (opći podaci i radnici).',
        tabByWorker: 'Po radniku',
        tabByProject: 'Po projektu',
        fromDate: 'Od',
        toDate: 'Do',
        worker: 'Radnik',
        project: 'Projekt',
        allProjects: 'Svi projekti',
        runReport: 'Prikaži izvještaj',
        totalHours: 'Ukupno sati',
        byProject: 'Po projektu',
        dailyBreakdown: 'Dnevni pregled',
        projectName: 'Projekt',
        hours: 'Sati',
        date: 'Datum',
        name: 'Naziv',
        type: 'Vrsta',
        typePerson: 'Osoba',
        typeSubcontractor: 'Kooperantska tvrtka',
        noData: 'Nema sati za odabrane filtre.',
        invalidDateRange: 'Datum završetka mora biti jednak ili nakon datuma početka.',
        selectWorker: 'Odaberite radnika',
        selectProject: 'Odaberite projekt',
        expandDaily: 'Prikaži dnevne sate',
        collapseDaily: 'Sakrij dnevne sate',
        expandHistory: 'Prikaži povijest promjena',
        collapseHistory: 'Sakrij povijest promjena',
        changeHistory: 'Povijest promjena',
        lunchUsed: 'Ručak iskorišten',
        lunchReduced: 'Ručak (−{{hours}} h)',
      },
      myHours: {
        title: 'Moji sati',
        subtitle: 'Vaši evidentirani radni sati iz dnevnog unosa rada. Proširite redak da vidite tko je unio ili mijenjao sati.',
        previousMonth: 'Prethodni mjesec',
        nextMonth: 'Sljedeći mjesec',
        totalHours: 'Ukupno sati',
        date: 'Datum',
        project: 'Projekt',
        hours: 'Sati',
        noData: 'Nema evidentiranih sati za ovaj mjesec.',
        notLinked: 'Vaš račun nije povezan s djelatnikom. Zamolite administratora da poveže vaš korisnički račun u Korisnicima.',
        noPermission: 'Nemate dopuštenje za pregled ove stranice.',
        changeHistory: 'Povijest promjena',
        expandHistory: 'Prikaži povijest promjena',
        collapseHistory: 'Sakrij povijest promjena',
      },
      personnelHoursHistory: {
        loading: 'Učitavanje povijesti…',
        noHistory: 'Nema zabilježenih promjena.',
        unknownUser: 'Nepoznati korisnik',
        byUser: '{{user}} · {{date}}',
        yes: 'Da',
        no: 'Ne',
        created: 'Unos kreiran',
        createdHours: 'Kreirano — {{hours}} h',
        deleted: 'Unos obrisan',
        deletedWasHours: 'Obrisano — bilo je {{hours}} h',
        updated: 'Unos ažuriran',
        hoursChanged: 'Sati: {{from}} → {{to}}',
        rainDaySet: 'Kišni dan: {{value}}',
        rainDayChanged: 'Kišni dan: {{from}} → {{to}}',
        notesChanged: 'Bilješke ažurirane',
        notesSet: 'Bilješka dodana',
        timeRangeSet: 'Vrijeme {{from}}–{{to}}',
        timeRangeChanged: 'Vrijeme {{fromStart}}–{{fromEnd}} → {{toStart}}–{{toEnd}}',
        lunchSet: 'Ručak: {{value}}',
        lunchChanged: 'Ručak {{from}} → {{to}}',
        lunchReductionSet: 'Smanjenje zbog ručka: {{hours}} h',
        lunchReductionChanged: 'Smanjenje zbog ručka {{from}} → {{to}} h',
        hasEdits: 'Ovaj unos je uređen nakon prvog spremanja',
      },
      projectDetails: {
        tabs: {
          overview: 'Pregled',
          deadlineUpdates: 'Ažuriranja rokova',
          costSheets: 'Troškovnici',
          generalTasks: 'Opći zadaci',
          resources: 'Resursi',
          personnel: 'Djelatnici',
          floorplans: 'Tlocrti',
          otherDocuments: 'Ostali dokumenti',
        },
        projectDetails: 'Detalji projekta',
        updateDeadline: 'Ažuriraj rok',
        newEndDate: 'Novi završni datum',
        noPreviousDate: 'Nema prethodnog datuma',
        note: 'Bilješka',
        saveUpdate: 'Spremi ažuriranje',
        updatedDate: 'Ažurirani datum',
        previousDate: 'Prethodni datum',
        updatedAt: 'Ažurirano',
        itemType: 'Vrsta stavke',
        noCostSheets: 'Nema troškovnika. Učitajte Excel datoteku za početak.',
        linkCostSheets: 'Poveži troškovnike',
        linkSelected: 'Poveži odabrane',
        daysLate: 'dana kašnjenja',
        daysRemaining: 'dana preostalo',
        itemCount: '{{count}} stavki',
        uploadedAt: 'Učitano',
        downloadDocument: 'Preuzmi',
        downloadDocumentFailed: 'Preuzimanje dokumenta nije uspjelo',
        downloadNotAvailable: 'Datoteka nije dostupna za preuzimanje',
        deleteDocument: 'Obriši dokument',
        deleteDocumentConfirm: 'Obrisati ovaj dokument i svih {{count}} povezanih stavki troškovnika? Ova radnja se ne može poništiti.',
        deleteDocumentBlocked: 'Dokument se ne može obrisati jer su neke stavke povezane s količinama rada ili troškovima.',
        manualEntries: 'Ručni unosi',
        expand: 'Prikaži stavke',
        collapse: 'Sakrij stavke',
        costSheetCoverage: 'Pokrivenost troškovnika',
        unassignedCostSheets: '{{count}} troškovnik(a) nije dodijeljeno nijednom zadatku',
        noCostSheetsYet: 'Još nema troškovnika u ovom projektu.',
        newTaskName: 'Naziv novog zadatka',
        addTask: 'Dodaj zadatak',
        addExistingGeneralTask: 'Dodaj postojeći opći zadatak',
        createNewGeneralTask: 'Kreiraj novi opći zadatak',
        categoryFreeSoloHint: 'Odaberite postojeću kategoriju ili unesite novu',
        createAndAssign: 'Kreiraj i dodijeli',
        selectExistingTask: 'Odaberi postojeći opći zadatak',
        addSelectedTask: 'Dodaj odabrani',
        quickCreateHint: 'Ili unesite novi naziv za stvaranje i dodjelu',
        editTaskName: 'Uredi naziv zadatka',
        linkedPositions: '{{count}} povezanih pozicija',
        showCostSheets: 'Prikaži troškovnike',
        hideCostSheets: 'Sakrij troškovnike',
        deleteTaskConfirm: 'Ukloniti ovaj zadatak s projekta? Poveznice na troškovnike bit će uklonjene. Zadatak u katalogu ostaje.',
        noGeneralTasks: 'Još nema općih zadataka na ovom projektu. Dodajte postojeći ili kreirajte novi opći zadatak.',
        allCostSheetsAssigned: 'Svi troškovnici su već dodijeljeni zadatku.',
        noCatalogTasksAvailable: 'Svi zadaci iz kataloga su već na ovom projektu.',
        searchCostSheets: 'Pretraži troškovnike',
        searchByCodeOrName: 'Pretraži po šifri ili nazivu',
        sortCodeAsc: 'Šifra A→Z',
        sortCodeDesc: 'Šifra Z→A',
        selectAllInList: 'Odaberi sve na popisu ({{count}})',
        noCostSheetsMatch: 'Nijedan troškovnik ne odgovara pretrazi.',
        toolName: 'Naziv alata',
        assignedTo: 'Dodijeljeno',
        materialType: 'Vrsta materijala',
        deliveryDate: 'Datum isporuke',
        projectPersonnel: 'Djelatnici projekta',
        totalHours: 'Ukupno sati',
        objectName: 'Naziv objekta',
        floors: 'Katovi',
        addObject: 'Dodaj objekt',
        floorNumber: 'Kat {{number}}',
        floorNamePlaceholder: 'Naziv (npr. Podrum)',
        noFileUploaded: 'Nema učitane datoteke za ovaj kat.',
        otherDocuments: {
          addDocument: 'Dodaj dokument',
          name: 'Naziv',
          notes: 'Bilješke',
          file: 'Dokument',
          selectFile: 'Odaberi datoteku',
          noDocuments: 'Još nema prenesenih dokumenata.',
          previewFailed: 'Pregled dokumenta nije uspio',
          downloadFailed: 'Preuzimanje dokumenta nije uspjelo',
          deleteConfirm: 'Obrisati ovaj dokument? Ova radnja se ne može poništiti.',
          uploading: 'Prijenos...',
        },
      },
      costSheetUpload: {
        pleaseUploadExcel: 'Molimo učitajte Excel (.xlsx) datoteku',
        uploadFailed: 'Učitavanje datoteke nije uspjelo. Pokušajte ponovno.',
        uploading: 'Učitavanje i obrada troškovnika...',
        dropHere: 'Ispustite datoteku ovdje',
        dragAndDrop: 'Povucite i ispustite Excel datoteku ovdje ili kliknite za odabir',
        onlyXlsx: 'Prihvaćaju se samo .xlsx datoteke',
        createdResult: 'Kreirano {{costSheets}} troškovnika i {{categories}} kategorija.',
        importWarnings: 'Upozorenja pri uvozu:',
      },
      tools: {
        addTool: 'Dodaj alat',
        editTool: 'Uredi alat',
        assign: 'Dodijeli',
        assignments: 'Zaduženja',
        currentAssignments: 'Trenutna zaduženja',
        newAssignment: 'Novo zaduženje',
        assignTool: 'Dodijeli alat',
        noNotes: 'Nema bilješki',
        fields: {
          type: 'Vrsta',
          serialNumber: 'Serijski broj',
          dateReceived: 'Datum zaprimanja',
          dateReturned: 'Datum povrata',
          serial: 'Serijski broj',
        },
      },
      materials: {
        fields: {
          registration: 'Registracija',
          registrationDate: 'Datum registracije',
        },
      },
      warehouse: {
        tabs: {
          inventory: 'Inventar',
          templates: 'Predlošci',
        },
        sections: {
          materials: 'Materijali',
          machines: 'Strojevi',
          equipment: 'Oprema',
          tools: 'Alati',
        },
        templates: {
          machineTemplates: 'Predlošci strojeva',
        },
        addMaterial: 'Dodaj materijal',
        addMachine: 'Dodaj stroj',
        addEquipment: 'Dodaj opremu',
        inboundTitle: 'Ulaz u skladište',
        inboundMode: 'Vrsta ulaza',
        inboundOpening: 'Početno / postojeće stanje (bez dokumenta)',
        inboundPurchase: 'Od dobavljača (s dokumentom)',
        inboundOpeningHint: 'Koristite za zatečene zalihe pri uključivanju aplikacije. Otpremnica ili račun se ne kreiraju.',
        inboundPurchaseHint: 'Unesite samo što je stiglo u skladište. Ista otpremnica može se koristiti i na gradilištima.',
        inboundFailed: 'Ulaz u skladište nije spremljen.',
        itemCategory: { Material: 'Materijal', Equipment: 'Oprema', Machine: 'Stroj', Tool: 'Alat' },
        addMachineTemplate: 'Dodaj predložak stroja',
        editMachineTemplate: 'Uredi predložak stroja',
        machineTemplate: 'Predložak stroja',
        deleteMachineTemplateConfirm: 'Jeste li sigurni da želite obrisati ovaj predložak stroja?',
        errorDeletingMachineTemplate: 'Greška pri brisanju predloška stroja',
        errorSavingMachineTemplate: 'Greška pri spremanju predloška stroja',
        customFields: 'Prilagođena polja',
        addField: 'Dodaj polje',
        fieldName: 'Naziv polja',
        fieldType: 'Tip polja',
        required: 'Obavezno',
        optional: 'Neobavezno',
        dueDateExpires: 'Rok (ističe)',
        machineFiles: 'Datoteke stroja',
        assignTemplateForFiles: 'Dodijelite predložak ovom stroju prije upravljanja datotekama.',
        noFilesInCategory: 'Nema prenesenih datoteka za ovaj stroj u ovoj kategoriji.',
        fieldOptions: 'Opcije',
        fieldOptionsHint: 'Jedna opcija po retku',
        noTemplate: 'Bez predloška',
        fieldCount: '{{count}} polja',
        moveFieldUp: 'Pomakni polje gore',
        moveFieldDown: 'Pomakni polje dolje',
        deleteField: 'Obriši polje',
        requiredFieldsMissing: 'Ispunite sva obavezna polja predloška',
        selectOptionsRequired: 'Padajuća polja trebaju barem jednu opciju',
        fieldTypes: {
          text: 'Tekst',
          date: 'Datum',
          number: 'Broj',
          select: 'Padajući izbornik',
        },
      },
      dates: {
        increaseByDay: 'Povećaj datum za 1 dan',
        decreaseByDay: 'Smanji datum za 1 dan',
        months: [
          'Siječanj', 'Veljača', 'Ožujak', 'Travanj', 'Svibanj', 'Lipanj',
          'Srpanj', 'Kolovoz', 'Rujan', 'Listopad', 'Studeni', 'Prosinac',
        ],
        weekdaysShort: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
        calendarAria: 'Kalendar za {{month}} {{year}}. Odaberite datum.',
      },
    },
  },
};
